// extracted by mini-css-extract-plugin
export default {"diary-head":"DiaryList_diary-head__LlS61","diary-list":"DiaryList_diary-list__roDwp"};